import { useEffect } from 'react';
import { DEFAULT_TITLE } from './seo.js';

/**
 * Sets document.title on mount and restores the default title on unmount.
 * @param {string} [title] - The page-specific title (e.g. "Projects")
 * @param {boolean} [exact=false] - If true, uses title directly without suffix
 */
export function useDocumentTitle(title, exact = false) {
  useEffect(() => {
    if (!title) {
      document.title = DEFAULT_TITLE;
      return;
    }

    document.title = exact ? title : `${title} | YACC - IIT Palakkad`;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, exact]);
}

export default useDocumentTitle;
